export default __webpack_public_path__ + "static/media/add_item.1abb6d2a.svg";